(() => {
  const blockClasses = [
    "multiscale-block-intro",
    "multiscale-block-image multiscale-block-image-one",
    "multiscale-block-image multiscale-block-image-two",
    "multiscale-block-origin",
    "multiscale-block-development",
    "multiscale-block-image multiscale-block-image-three",
    "multiscale-block-image multiscale-block-image-four",
    "multiscale-block-guide",
  ];

  function buildDiagram() {
    const diagram = document.createElement("div");
    diagram.className = "multiscale-diagram";
    diagram.setAttribute("role", "img");
    diagram.setAttribute(
      "aria-label",
      "Diagram showing longer bass strings and shorter treble strings across angled frets",
    );
    diagram.innerHTML = `
      <span class="multiscale-diagram__label multiscale-diagram__label--bass">Longer bass scale</span>
      <span class="multiscale-diagram__label multiscale-diagram__label--treble">Shorter treble scale</span>
      <i></i><i></i><i></i><i></i><i></i><i></i>
      <b></b><b></b><b></b><b></b><b></b>
    `;
    return diagram;
  }

  function structureIntro(block) {
    if (!block) return;
    const richText = block.querySelector(".enhanced-richtext");
    const nodes = richText ? [...richText.children] : [];
    if (nodes.length < 10) return;

    const copy = document.createElement("div");
    copy.className = "multiscale-intro-copy";
    nodes.slice(0, 4).forEach((node) => copy.append(node));
    copy.firstElementChild?.classList.add("multiscale-eyebrow");

    const benefits = document.createElement("div");
    benefits.className = "multiscale-benefits";
    const benefitNodes = nodes.slice(4);
    for (let index = 0; index < benefitNodes.length; index += 2) {
      const article = document.createElement("article");
      const number = document.createElement("span");
      number.textContent = String(index / 2 + 1).padStart(2, "0");
      article.append(number, ...benefitNodes.slice(index, index + 2));
      benefits.append(article);
    }

    richText.replaceChildren(copy, buildDiagram(), benefits);
  }

  function structureGuide(block) {
    if (!block) return;
    const richText = block.querySelector(".enhanced-richtext");
    const nodes = richText ? [...richText.children] : [];
    if (nodes.length < 8) return;

    const heading = document.createElement("div");
    heading.className = "multiscale-guide__heading";
    nodes.slice(0, 3).forEach((node) => heading.append(node));
    heading.firstElementChild?.classList.add("multiscale-eyebrow");

    const labels = ["Scale spread", "Under the hands", "Low-string response", "Everyday use", "Built as a system", "String choice"];
    const grid = document.createElement("div");
    grid.className = "multiscale-guide__grid";
    let article;
    let labelIndex = 0;

    nodes.slice(3).forEach((node) => {
      if (node.tagName === "H3") {
        article = document.createElement("article");
        const label = document.createElement("span");
        label.textContent = labels[labelIndex] || "Multiscale";
        labelIndex += 1;
        article.append(label, node);
        grid.append(article);
      } else {
        article?.append(node);
      }
    });

    const callToAction = document.createElement("a");
    callToAction.className = "multiscale-cta";
    callToAction.href = "/collections/multiscale";
    callToAction.innerHTML = 'Explore multiscale guitars <span aria-hidden="true">→</span>';

    const guide = document.createElement("div");
    guide.className = "multiscale-guide";
    guide.append(heading, grid, callToAction);
    richText.replaceChildren(guide);
  }

  function initializeMultiscalePage() {
    const section = document.querySelector(".template-page-what-is-a-multiscale .ormsby-section-container");
    if (!section || section.dataset.multiscaleInitialized === "true") return;

    section.dataset.multiscaleInitialized = "true";
    section.classList.add("multiscale-page");

    section.querySelectorAll(".flex-layout > .flex-item").forEach((block, index) => {
      blockClasses[index]?.split(" ").forEach((className) => block.classList.add(className));

      const image = block.querySelector("img");
      if (image && (!image.alt || /^(image description|full width image)$/i.test(image.alt))) {
        image.alt = "Ormsby multiscale guitar detail";
      }
    });

    structureIntro(section.querySelector(".multiscale-block-intro"));
    structureGuide(section.querySelector(".multiscale-block-guide"));
    section
      .querySelectorAll(".multiscale-block-origin .enhanced-richtext > p:first-child, .multiscale-block-development .enhanced-richtext > p:first-child")
      .forEach((eyebrow) => eyebrow.classList.add("multiscale-eyebrow"));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeMultiscalePage);
  } else {
    initializeMultiscalePage();
  }

  document.addEventListener("shopify:section:load", initializeMultiscalePage);
})();
